import { Component } from 'react'
import styled from 'glamorous'
import { map, filter } from 'lodash'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { withRouter } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'

import { client } from 'config'
import { $, getLocationQuery, getUrlSearch, getError } from 'utils'
import { withConsumer } from 'store'
import { Button, Icon, InfoRow, HeaderRow, Loader, EditableName, Tooltip, ImagePure, Date, ListItem } from 'components'
import { AddListPanel, AddFacesPanel, MatchPanel } from 'components/panels'
import { PERSONS, PERSON, UpdatePersonMutation, DeletePersonMutation, AttachDescriptorToPerson,
  DetachDescriptorFromPerson, AttachListToPerson, DetachListFromPerson } from 'queries'

const Container = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'hidden'
})

const DetailsInfoContainer = styled.div({
  position: 'absolute',
  width: '100%',
  height: '100%',
}, 'detailsInfoContainer')

const DetailsInfoContainerInner = styled(PerfectScrollbar)({
  position: 'relative',
}, 'scrollableContainer')

const Block = styled.div({
  padding: 30,
  borderBottom: '1px solid var(--borderColor)',
})

const InfoButtons = styled.div({
  width: '100%',
  display: 'flex',
  marginTop: 20,
})

const PersonsBlock = styled.div({
  padding: 30,
})

const PhotoContainer = styled.div({
  display: 'flex',
  flexFlow: 'row wrap',
  alignItems: 'flex-start',
  alignContent: 'flex-start',
  marginTop: 20,
  marginLeft: -10,
})

const Photo = styled.div({
  marginLeft: 10,
  marginBottom: 10
})

const PanelContainer = styled.div({
  position: 'absolute',
  left: 0,
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  zIndex: 1,
}, 'PanelContainer')

const BottomBar = styled.div({
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginTop: 20,
})

const ExternalId = styled.input({
  margin: 0,
  padding: 0,
  border: 0
})

class DetailsInfo extends Component {

  updatePersonData = value => {
    const { updatePerson, person, match } = this.props
    return updatePerson({
      variables: {
        uuid: person.uuid,
        ...value
      },
      update: (proxy, { data: { updatePerson } }) => {
        if (updatePerson.ok) {
          const variables = {
            uuid: match.params.id,
            ...personDescriptorsVariables
          }
          const data = proxy.readQuery({ query: PERSON, variables })
          data.person = {...data.person, ...value}
          proxy.writeQuery({ query: PERSON, data, variables })
        }
      }
    })
      // .catch(error => this.props.setErrorMessage(getError(error)))
  }

  updateUserData = userData =>
    this.updatePersonData({ userData })
  
  updateExternalid = event =>
    this.updatePersonData({ externalId: event.target.value })

  getUpdatedVariables = () => {
    let variables = getVariables(getLocationQuery(this.props.location))
    const cacheData = client.cache.readQuery({ query: PERSONS, variables })
    if ((cacheData.persons.count - 1) % variables.limit === 0) {
      if (cacheData.persons.count === 1) {
        variables = getVariables()
      } else {
        variables.offset -= 1
      }
    }
    return variables
  }

  //  TODO refactor to opmitisticUpdate + update cache
  deletePerson = () => {
    const variables = this.getUpdatedVariables()
    return this.props.deletePerson({
      variables: { uuid: this.props.person.uuid },
      refetchQueries: [{
        query: PERSONS,
        variables,
      }]
    })
    .then((response) => {
      if (response.data.deletePerson.ok) {
        const variables = this.getUpdatedVariables()
        this.props.history.push({
          pathname: '/persons',
          search: getUrlSearch(variables),
        })
      }
    })
    .catch(error => this.props.setErrorMessage(getError(error)))}
  

  // TODO Refactor to stateless implementation with debounced input with initial value
  state = { externalId: this.props.person.externalId }

  componentWillReceiveProps = ({ person }) =>
    person.externalId !== this.state.externalId &&
      this.setState({ externalId: person.externalId })

  handleExternalId = ({ target }) =>
    this.setState({ externalId: target.value })

  render() {
    const { openBottomView, person, setAddMode, fetchMore, history } = this.props
    const { uuid, createTime, userData, lists, descriptors, descriptorsCount } = person
    return (
      $(DetailsInfoContainer,
        $(DetailsInfoContainerInner,
          $(Block,
            $(HeaderRow, { label: $(EditableName, { key: uuid, value: userData, onUpdate: this.updateUserData }) },
              $(Tooltip, { tip: 'Delete person' },
                $(Icon, {
                  type: 'delete',
                  onClick: this.deletePerson
                })
              )
            ),
            $(InfoRow, { name: 'ID:', value: uuid }),
            $(InfoRow, {
              name: 'External ID:',
              value: $(ExternalId, {
                value: this.state.externalId || '',
                onChange: this.handleExternalId,
                onBlur: this.updateExternalid }) }),
            $(InfoRow, { name: 'Create time:', value: $(Date, { value: createTime }) }),
            $(InfoRow, { name: 'Last update:', value: $(Date, { value: createTime }) }),
            $(InfoButtons,
              $(Button, {
                bgColor: '#82CA60',
                width: '75px',
                primary: true,
                isDisabled: descriptors.length === 0,
                onClick: () => openBottomView('match')
              }, 'Match'),
              $(Button, {
                bgColor: '#64B1F2',
                width: '75px',
                primary: true,
                isDisabled: descriptors.length === 0,                
                onClick: () => openBottomView('identify'),
                style: { marginLeft: 10 },
              }, 'Ident'),
            )
          ),
          $(Block,
            $(HeaderRow, { label: 'Lists', count: lists.length },
              $(Tooltip, { tip: 'Add lists' },
                $(Icon, { type: 'add', onClick: () => setAddMode('lists') })
              )
            ),
            map(lists, (list, i) =>
              $(ListItem, {
                key: i,
                last: i === lists.length - 1,
                name: list.listData,
                value: list.uuid,
                isHoverable: true,
                onClick: () => history.push({ pathname: `/list/persons/${list.uuid}` }),
              })
            )
          ),
          $(PersonsBlock,
            $(HeaderRow, { label: 'Faces', count: descriptorsCount },
              $(Tooltip, { tip: 'Add faces' },
                $(Icon, { type: 'add', onClick: () => setAddMode('faces') })
              )
            ),
            $(PhotoContainer,
              map(descriptors, (descriptor, key) =>
                $(Photo, {
                  key,
                  onClick: () => history.push({ pathname: `/faces/${descriptor.uuid}` })
                },
                  $(ImagePure, {
                    src: descriptor.portrait,
                    width: 100,
                    height: 130,
                    isHoverable: true
                  })
                )
              )
            ),
            descriptors.length > 0 && descriptors.length < descriptorsCount &&
            $(BottomBar,
              $(Button, {
                onClick: fetchMore,
                bgColor: '#9a9af2',
                primary: true,
                width: '185px',
              }, 'Show more'),
            )
          )
        )
      )
    )
  }
}

export class DetailsPage extends Component {

  state = {
    bottomView: undefined,
    addMode: undefined,
  }


  componentWillMount() {
    this.setState({
      offset: this.props.data.variables.offset,
      limit: this.props.data.variables.limit
    })
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.match.params.id !== nextProps.match.params.id) {
      this.setState({ bottomView: undefined, addMode: undefined })
    }
  }

  showBottomPanel = (bottomView) => this.setState({ bottomView })
  setAddMode = (mode) => this.setState({ addMode: mode })

  fetchMore = () => {
    this.setState({ offset: this.state.offset + 1 }, () =>
      this.props.data.fetchMore({
        variables: {
          offset: this.state.offset,
        },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          const newItems = [...prev.person.descriptors, ...fetchMoreResult.person.descriptors]
          return {...prev, person: { ...prev.person, descriptors: newItems }}
        }
      })
    )
  }

  detachDescriptorFromPerson = (items, needRefetch) => {
    this.setState({ offset: 1 })
    return this.props.detachDescriptorFromPerson({
      variables: {
        personUUID: this.props.data.person.uuid,
        descriptorUUIDs: map(items, item => item.uuid),
      },
      ...needRefetch && {
        refetchQueries: [{
          query: PERSONS,
          variables: getVariables(getLocationQuery(this.props.location))
        }, {
          query: PERSON,
          variables: {
            uuid: this.props.data.person.uuid,
            ...personDescriptorsVariables
          }
        }]
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  attachDescriptorToPerson = (items) => {
    this.setState({ offset: 1 })
    return this.props.attachDescriptorToPerson({
      variables: {
        personUUID: this.props.data.person.uuid,
        descriptorUUIDs: map(items, item => item.uuid),
      },
      refetchQueries: [{
        query: PERSONS,
        variables: getVariables(getLocationQuery(this.props.location))
      }, {
        query: PERSON,
        variables: {
          uuid: this.props.data.person.uuid,
          ...personDescriptorsVariables
        }
      }]
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  handleSubmitFaces = async (detach, attach) => {
    if (detach.length > 0) {
      await this.detachDescriptorFromPerson(detach, attach.length === 0)
    }
    if (attach.length > 0) {
      this.attachDescriptorToPerson(attach)
    }
  }

  detachListFromPerson = (items) => {
    return this.props.detachListFromPerson({
      variables: {
        personUUID: this.props.data.person.uuid,
        listUUIDs: map(items, item => item.uuid),
      },
      update: (proxy, { data: { detachListFromPerson } }) => {
        if (detachListFromPerson.ok) {
          const variables = {
            uuid: this.props.data.person.uuid,
            ...personDescriptorsVariables
          }
          const data = proxy.readQuery({ query: PERSON, variables })
          data.person.lists = filter(data.person.lists, list =>
            !items.some(item => item.uuid === list.uuid))
          proxy.writeQuery({ query: PERSON, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  attachListToPerson = (items) => {
    return this.props.attachListToPerson({
      variables: {
        personUUID: this.props.data.person.uuid,
        listUUIDs: map(items, item => item.uuid),
      },
      update: (proxy, { data: { attachListToPerson } }) => {
        if (attachListToPerson.ok) {
          const variables = {
            uuid: this.props.data.person.uuid,
            ...personDescriptorsVariables
          }
          const data = proxy.readQuery({ query: PERSON, variables })
          data.person.lists = [...map(items, item => ({
            uuid: item.uuid,
            listData: item.listData,
            __typename: "List"
          })), ...(data.person.lists || [])]
          proxy.writeQuery({ query: PERSON, data, variables })
        }
      }
    })
      .catch(error => this.props.setErrorMessage(getError(error)))
  }

  handleSubmitLists = async (newItems) => {
    const oldItems = this.props.data.person.lists
    const detach = filter(oldItems, old =>
      !newItems.some(item => item.uuid === old.uuid))
    const attach = filter(newItems, item =>
      !oldItems.some(old => old.uuid === item.uuid))
    if (detach.length > 0) {
      await this.detachListFromPerson(detach, attach.length === 0)
    }
    if (attach.length > 0) {
      this.attachListToPerson(attach)
    }
  }

  render() {
    const { bottomView, addMode } = this.state
    const { data: { loading, person } } = this.props
    if (loading && !person) return $(Loader)
    return (
      $(Container,
        $(DetailsInfo, {
          ...this.props,
          person,
          fetchMore: this.fetchMore,
          setAddMode: this.setAddMode,
          openBottomView: this.showBottomPanel
        }),
        bottomView === 'match' && $(PanelContainer,
          $(MatchPanel, {
            person,
            closePanel: () => this.showBottomPanel(false),
          })
        ),
        bottomView === 'identify' && $(PanelContainer,
          $(MatchPanel, {
            person,
            matchType: 'identify',
            closePanel: () => this.showBottomPanel(false),
          })
        ),
        addMode === 'lists' && $(AddListPanel, {
          type: 'persons',
          selected: person.lists,
          onClose: () => this.setAddMode(),
          onSubmit: this.handleSubmitLists,
        }),
        addMode === 'faces' && $(AddFacesPanel, {
          syncMode: true,
          targetType: 'person',
          targetId: person.uuid,
          isLock: true,
          onClose: () => this.setAddMode(),
          onSubmit: this.handleSubmitFaces,
        })
      )
    )
  }
}

export default withRouter(
  compose(
    graphql(UpdatePersonMutation, {name: 'updatePerson'}),
    graphql(DeletePersonMutation, {name: 'deletePerson'}),
    graphql(AttachDescriptorToPerson, {name: 'attachDescriptorToPerson'}),
    graphql(DetachDescriptorFromPerson, {name: 'detachDescriptorFromPerson'}),
    graphql(AttachListToPerson, {name: 'attachListToPerson'}),
    graphql(DetachListFromPerson, {name: 'detachListFromPerson'}),
    graphql(PERSON, {
      options: props => ({
        fetchPolicy: 'cache-and-network',
        variables: {
          uuid: props.match.params.id,
          ...personDescriptorsVariables
        }
      })
    })
  )(withConsumer(DetailsPage)))

const getVariables = (queryParams = {}) => ({
  limit: +queryParams.limit || 5,
  offset: +queryParams.offset || 1,
})

const personDescriptorsVariables = {
  offset: 1,
  limit: 9
}


// WEBPACK FOOTER //
// ./src/pages/Persons/DetailsPage.js